<template>
  <div>
    <div class="rp-cart-container rp-modal" :class="{ 'is-active': isActive }"
      v-bind:style="{
        fontFamily: getGlobalFont
      }">
      <div class="rp-modal-background"></div>
      <div class="rp-modal-content">
        <div class="rp-container-modal">
          <div
            class="rp-header-modal rp-columns is-gapless is-mobile"
            v-bind:style="{
              backgroundColor: color.primaryMain,
              color: color.primarySub
            }"
          >
            <div class="rp-column is-2">
              <a v-on:click="backPage" class="rp-back-button" v-bind:class="{ 'visible': showGoBackButton && checkCompletedOrder === false }" v-bind:style="{ color: color.primarySub }">
                <span class="rp-icon">
                  <i class="fa fa-chevron-left"></i>
                </span>
                <span class="is-hidden-mobile">{{ t.back }}</span>
              </a>
            </div>

            <div class="rp-page rp-column rp-helper-text-center">
              {{ pageName }}
            </div>

            <div class="rp-column rp-helper-text-right is-2">
              <a v-if="checkCompletedOrder === false" v-on:click="closeCart" v-bind:style="{ color: color.primarySub }">
                <span class="is-hidden-mobile">{{ t.close }}</span>
                <span class="rp-icon">
                  <i class="fa fa-times"></i>
                </span>
              </a>
            </div>
          </div>

          <div class="rp-content-modal" id="rp-content-modal">
            <component :is="currentView" v-on:changeCurrentView="changeCurrentView"></component>
          </div>

          <div v-if="checkCompletedOrder === true" class="rp-completed-order-notice">
            {{ t.orderCompleted }}
            <button
              class="rp-button"
              v-on:click="clearCompletedOrder"
              v-bind:style="{
                backgroundColor: color.secondaryMain,
                color: color.secondarySub,
                borderColor: color.secondaryMain
              }"
            >
              {{ t.clear }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div
      class="rp-out-of-stock-container rp-modal"
      v-bind:class="{ 'is-active': isOutOfStock }"
      v-bind:style="{
        fontFamily: getGlobalFont
      }"
    >
      <div class="rp-modal-background"></div>
      <div class="rp-modal-content">
        <div
          class="rp-header-modal is-gapless is-mobile"
          v-bind:style="{
            backgroundColor: color.primaryMain,
            color: color.primarySub
          }"
        >
          <div class="rp-helper-text-right is-2">
            <a v-on:click="closeOutOfStockModal" v-bind:style="{ color: color.primarySub }">
              <span>{{ t.close }}</span>
              <span class="rp-icon">
                <i class="fa fa-times"></i>
              </span>
            </a>
          </div>
        </div>
        <div class="rp-content-modal" id="rp-content-modal">
          <div class="rp-helper-text-center">
            {{ t.outOfStock }}
          </div>
          <br />
          <div class="rp-helper-text-center">
            <button
              class="rp-button"
              v-on:click="closeOutOfStockModal"
              v-bind:style="{
                backgroundColor: color.secondaryMain,
                color: color.secondarySub,
                borderColor: color.secondaryMain
              }"
            >
            {{ t.ok }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { Cart } from '@/store/Cart'

const CartView = () => import('./CartView')
const CartEmpty = () => import('./CartEmpty')
const CartProductDeleted = () => import('./CartProductDeleted')
const CartConfirm = () => import('./CartConfirm')
const ThankYou = () => import('./ThankYou')
const PaymentSlip = () => import('./PaymentSlip')
const PaymentSlipResult = () => import('./PaymentSlipResult')

export default {
  name: 'Cart',
  components: {
    CartView,
    CartEmpty,
    CartProductDeleted,
    CartConfirm,
    ThankYou,
    PaymentSlip,
    PaymentSlipResult
  },
  props: {
    publicToken: {
      type: String,
      default: ''
    },
    member: {
      type: Number,
      default: 0
    },
    memberId: {
      type: Number,
      default: 0
    },
    locale: {
      type: String,
      default: 'en'
    },
    primaryMainColor: {
      type: String,
      default: '#235'
    },
    primarySubColor: {
      type: String,
      default: '#efefef'
    },
    secondaryMainColor: {
      type: String,
      default: '#47e'
    },
    secondarySubColor: {
      type: String,
      default: '#efefef'
    },
    linkColor: {
      type: String,
      default: '#3273dc'
    },
    system: {
      type: String,
      default: 'Velaeasy'
    },
    shappyDomain: {
      type: String,
      default: ''
    },
    shappyCustomToken: {
      type: String,
      default: ''
    },
    shappyAppId: {
      type: String,
      default: '0'
    },
    shappyChannelId: {
      type: String,
      default: '0'
    },
    shappyProfileId: {
      type: String,
      default: ''
    },
    shappyChannelName: {
      type: String,
      default: ''
    },
    firstname: {
      type: String,
      default: ''
    },
    lastname: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    mobile: {
      type: String,
      default: ''
    },
    gclid: {
      type: String,
      default: ''
    },
    globalFont: {
      type: String,
      default: ''
    },
    multiLanguageId: {
      type: String,
      default: ''
    },
    openModal: {
      type: Number,
      default: 0
    },
    orderId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      currentView: 'CartView',
      openCart: false
    }
  },
  computed: {
    t () {
      if (Cart.getLocale() == 'en') {
        return {
          back: 'Back',
          close: 'Close',
          yourShoppingCart: 'Your Product List',
          confirmAndPay: 'Confirm & Pay',
          thankYou: 'Thank You',
          outOfStock: 'There are not enough products in stock.',
          ok: 'OK',
          attachPaymentSlip: 'Confirm Payment',
          orderCompleted: 'This order is already completed',
          clear: 'Clear'
        }
      } else if (Cart.getLocale() == 'th') {
        return {
          back: 'กลับ',
          close: 'ปิด',
          yourShoppingCart: 'รายการสินค้าของคุณ',
          confirmAndPay: 'ยืนยัน & ชำระเงิน',
          thankYou: 'ขอบคุณ',
          outOfStock: 'สินค้าไม่เพียงพอ',
          ok: 'ตกลง',
          attachPaymentSlip: 'ส่งหลักฐานการชำระเงิน',
          orderCompleted: 'รายการสั่งซื้อนี้ได้ถูกดำเนินการต่อเรียบร้อยแล้ว',
          clear: 'เคลียร์'
        }
      } else if (Cart.getLocale() == 'vi') {
        return {
          back: 'Trở lại',
          close: 'Đóng',
          yourShoppingCart: 'Giỏ hàng của bạn',
          confirmAndPay: 'Xác nhận và thanh toán',
          thankYou: 'Cám ơn',
          outOfStock: 'Không có đủ sản phẩm trong kho hàng',
          ok: 'Đồng ý',
          attachPaymentSlip: 'Confirm Payment',
          orderCompleted: 'This order is already completed',
          clear: 'Clear'
        }
      }
    },
    isActive () {
      return this.openCart
    },
    isOutOfStock () {
      return Cart.isOutOfStock
    },
    pageName () {
      if (this.currentView === 'CartView') {
        return this.t.yourShoppingCart
      } else if (this.currentView === 'CartEmpty') {
        return this.t.yourShoppingCart
      } else if (this.currentView === 'CartProductDeleted') {
        return this.t.yourShoppingCart
      } else if (this.currentView === 'CartConfirm') {
        return this.t.confirmAndPay
      } else if (this.currentView === 'ThankYou') {
        return this.t.thankYou
      } else {
        return this.t.attachPaymentSlip
      }
    },
    color () {
      return Cart.getColor()
    },
    getGlobalFont () {
      return Cart.getGlobalFont()
    },
    products () {
      return Cart.getProducts()
    },
    showGoBackButton () {
      if (this.currentView === 'ThankYou' || this.currentView === 'PaymentSlip' || this.currentView === 'PaymentSlipResult') {
        return false
      } else {
        return true
      }
    },
    checkCompletedOrder () {
      return Cart.checkCompletedOrder()
    }
  },
  methods: {
    closeCart () {
      if (this.openModal === 1 && this.orderId === '') {
        window.history.back()
      } else {
        this.openCart = false
        this.currentView = 'CartView'
        let bodyBgElement = document.getElementById('body-bg')
        if (bodyBgElement !== null) {
          bodyBgElement.removeAttribute('style')
        }
      }
    },
    closeOutOfStockModal () {
      Cart.setIsOutOfStock(false)
    },
    backPage () {
      if (this.currentView === 'CartView' || this.currentView === 'CartEmpty') {
        this.closeCart()
      } else {
        this.currentView = 'CartView'
      }
    },
    clearCompletedOrder () {
      Cart.clearCartProducts()
      Cart.clearOrderId()
      this.closeCart()
    },
    changeCurrentView (view) {
      this.currentView = view
    }
  },
  mounted () {
    Cart.setToken(this.publicToken)
    this.$nextTick(async () => {
      if (this.products.length === 0 && this.openModal === 1) {
        this.currentView = 'CartEmpty'
      } else {
        this.currentView = 'CartView'
      }

      Cart.setSystem(this.system)
      if (this.system === 'ShopShappy') {
        Cart.setShappyProps(
          this.shappyCustomToken,
          this.shappyAppId,
          this.shappyChannelId,
          this.firstname,
          this.lastname,
          this.email,
          this.mobile,
          this.member,
          this.shappyDomain,
          this.shappyProfileId,
          this.shappyChannelName
        )
      }
      var locale = this.locale.toLowerCase()
      if (locale === '' || locale === 'th') {
        locale = 'th'
      } else if (locale === 'vi') {
        locale = 'vi'
      } else {
        locale = 'en'
      }
      Cart.setLocale(locale)
      Cart.setMember(this.member, this.memberId)
      Cart.setGclId(this.gclid)
      Cart.setGlobalFont(this.globalFont)
      Cart.setMultiLanguage(this.multiLanguageId)
      Cart.setColor(
        this.primaryMainColor,
        this.primarySubColor,
        this.secondaryMainColor,
        this.secondarySubColor,
        this.linkColor
      )
      Cart.getCurrencyAPI()
      Cart.getPropertiesAPI()
      Cart.setVelaeasyDomain(window.location.origin)

      let order = []
      let addProductResult = {}

      if ((this.orderId === '' || this.orderId === 'undefined') && Cart.getOrderId() !== '') {
        this.orderId = Cart.getOrderId()
        this.openModal = 0
      } else if (this.orderId !== 'undefined' && this.orderId !== '') {
        this.openModal = 1
      }

      if (this.orderId !== 'undefined' && this.orderId !== '') {
        Cart.setOrderId(this.orderId)
        order = await Cart.getOrderAPI(this.orderId)

        if (order.order.order_id) {
          Cart.setLocalStorage('order_id')
          Cart.setOrder(order.order)

          Cart.setAddress({
            'first_name': order.order.shipping_address_firstname,
            'last_name': order.order.shipping_address_lastname,
            'email': order.order.shipping_address_email,
            'phone': order.order.shipping_address_tel,
            'address': order.order.shipping_address_address,
            'address2': order.order.shipping_address_address_line2,
            'provinceId': order.order.shipping_address_province_id,
            'province_id': order.order.shipping_address_province_id,
            'province': order.order.shipping_address_province,
            'countryId': order.order.shipping_address_country,
            'districtId': order.order.shipping_address_district_id,
            'subDistrictId': order.order.shipping_address_sub_district_id,
            'district':  '',
            'subDistrict':  '',
            'postcode': order.order.shipping_address_postcode
          }, 'shipping')

          Cart.setAddress({
            'first_name': order.order.contact_address_firstname,
            'last_name': order.order.contact_address_lastname,
            'email': order.order.contact_address_email,
            'phone': order.order.contact_address_tel,
            'address': order.order.contact_address_address,
            'address2': order.order.contact_address_address_line2,
            'provinceId': order.order.contact_address_province_id,
            'province_id': order.order.contact_address_province_id,
            'province': order.order.contact_address_province,
            'countryId': order.order.contact_address_country,
            'districtId': order.order.contact_address_district_id,
            'subDistrictId': order.order.contact_address_sub_district_id,
            'district':  '',
            'subDistrict':  '',
            'postcode': order.order.contact_address_postcode
          }, 'billing')

          Cart.setAddressEdited(false)

          await Cart.clearCartProducts()

          for (let item of order.detail) {
            addProductResult = await Cart.addOrderToCart(item.sku, item.quantity)

            if (addProductResult === 'deleted_product') {
              if (Cart.checkCompletedOrder() === false) {
                this.currentView = 'CartProductDeleted'
                Cart.deleteProduct(item.sku, false)
              } else {
                Cart.setProduct({
                  id: item.product_id,
                  image_path: item.image_path,
                  product_name: item.name,
                  product_note: item.note,
                  normal_price: item.price,
                  sku: item.sku
                }, item.quantity)
              }
            }
          }

          if (this.products.length === 0 && this.openModal === 1 && this.currentView !== 'CartProductDeleted') {
            this.currentView = 'CartEmpty'
          }
        } else {
          Cart.clearCartProducts()
          Cart.clearOrderId()
        }
      } else if ((this.orderId === '' || this.orderId === 'undefined') && Cart.getOrderId() !== '') {
        this.orderId = Cart.getOrderId()
        Cart.setOrder(order.order)
      }

      if (this.orderId === 'undefined') {
        this.orderId = ''
      }

      if (this.openModal === 1) {
        this.openCart = true
      }

      Cart.$on('changeView', value => {
        this.currentView = value
      })
      Cart.$on('openCart', value => {
        this.openCart = value
        if (value === true) {
          let bodyBgElement = document.getElementById('body-bg')
          if (bodyBgElement !== null) {
            bodyBgElement.setAttribute('style', 'position: fixed;')
          }
        }
      })

      Cart.$on('closeCart', this.closeCart)
    })
  }
}
</script>

<style lang="scss" scoped>
// @import "~@/scss/custom.scss";
.rp-cart-container {
  .rp-modal-content {
    max-width: none !important;
    width: 100%;
    height: calc(100vh - 160px);
    max-height: calc(100vh - 160px);

    .rp-container-modal {
      overflow: hidden;
      background-color: #efefef;
      margin: 0 auto;
      height: 100%;
      position: relative;

      .rp-header-modal {
        margin-bottom: 0;
        padding: 15px;
        background-color: #235;
        .rp-page {line-height: 25px;}

        .rp-back-button {
          visibility: hidden;
        }

        .rp-back-button.visible {
          visibility: visible;
        }
      }
      .rp-content-modal {
        background-color: #efefef;
        padding: 1.5em;
        overflow: auto;
        height: calc(100% - 55px - 3em);
      }
      .rp-completed-order-notice {
        position: absolute;
        bottom: 0px;
        width: 100%;
        text-align: center;
        background-color: #fff;
        padding: 10px 0px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        button {
          margin: 0px 5px;
        }
      }
    }
  }
}

.rp-out-of-stock-container {
  .rp-header-modal {
    margin-bottom: 0;
    padding: 10px;
    background-color: #235;

    .rp-page {
      line-height: 25px;
    }
  }

  .rp-modal-content {
    max-width: 320px;

    .rp-content-modal {
      background-color: #efefef;
      padding: 1.5em;
    }
  }
}

@media screen and (max-width: 768px) {
  .rp-cart-container {
    padding: 0;
    .rp-modal-content{
      margin:0;
      background-color: #efefef;
      height: 100%;
      max-height: none;
      .rp-container-modal {
        width: 100%;
        .rp-header-modal {
          .rp-column {
            flex-basis: initial;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 769px) and (max-width: 1023px) {
  .rp-cart-container {
    .rp-container-modal {
      width: 728px;
    }
  }
}

@media screen and (min-width: 1024px){
  .rp-cart-container {
    .rp-container-modal {
      width: 984px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cart/index.vue